import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormGroupLabel, ErrorMessage, RequiredMark, StyledTextarea } from './BaseInput';

const Textarea = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  rows = 4,
  disabled = false,
  required = false,
  error,
  input,
  meta,
  ...props
}) => {
  // Usar input.value e input.onChange se disponível (React Final Form)
  const fieldValue = input ? input.value : value;
  const fieldOnChange = input ? input.onChange : onChange;
  const fieldName = input ? input.name : name; // Determinar se deve mostrar erro

  const hasError = error || meta && meta.touched && meta.error;
  const errorMessage = error || meta && meta.error;
  return <FormGroup>
      {label && <FormGroupLabel>
          {label}
          {required && <RequiredMark>*</RequiredMark>}
        </FormGroupLabel>}
      <StyledTextarea name={fieldName} rows={rows} value={fieldValue || ''} onChange={fieldOnChange} placeholder={placeholder} disabled={disabled} {...props} />
      {hasError && <ErrorMessage>
          {errorMessage}
        </ErrorMessage>}
    </FormGroup>;
};

Textarea.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};
export default Textarea;